import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  MaxLengthValidator,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { NgbAccordion } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from "@angular/common/http";
import { debounceTime, distinctUntilChanged, lastValueFrom, map, Observable } from "rxjs";
import { DatePipe, Location } from '@angular/common';

import {
  ColDef,
  FilterChangedEvent,
  FilterModifiedEvent,
  FilterOpenedEvent,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  PaginationChangedEvent,
  RowClickedEvent,
} from 'ag-grid-community';
import { BtnCellRenderer } from 'src/app/common/button-cell-renderer.component';
import { environment } from "../../../../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiHttpService } from "../../../../../_services/api-http.service";
import { MenusService } from "../../../../../_services/menu.service";
import { AlertService } from "../../../../../_services/alert.service";
import { PercentageDirective } from '../../percentage.directive';
import { MerchantService } from "../merchant.service";
import * as moment from "moment";
import { param } from 'jquery';

const { API_URL } = environment;



@Component({
  selector: 'app-merchant-mdr',
  templateUrl: './merchant-mdr.component.html',
  styleUrls: ['./merchant-mdr.component.scss']
})
export class MerchantMDRComponent implements OnInit {

  todayDate=this.datePipe.transform(new Date(), 'yyyy-MM-dd');
  @ViewChild('accPan') accPan: ElementRef;
  merchantMDRform: FormGroup;
  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 150,
    filter: false,
    resizable: true
  };

  mindatadis: boolean = true;
  maxdatadis: boolean = true;

  public rowData!: any[];
  // Allow key codes for special events. Reflect :
  tablecolumn: any;
  cardType: any;
  selectedMDRType: any;
  MDRType: any;
  currentPage: number = 1;
  pageSize: number = 10;
  globalSearch: string = '';
  collectionSize: number = 0;
  SingleRow: any;
  tableInfo: any;
  selectedMerchantID: any;
  isForm1Submitted: Boolean;
  public permissions: any = '';
  public columnDefs: ColDef[] = [
  { field: 'id', headerName: 'ID', hide: true },
  { field: 'acquirerName', tooltipField: 'sp_id', headerName: 'Acquirer', filter: 'agNumberColumnFilter' },
  // { field: 'acquirerName', headerName: 'Acquirer Name' },
  { field: 'paymentName', headerName: 'Payment Mode' },
   //{ field: 'bankId', tooltipField: 'bankId', headerName: 'Bank Name' },
  { field: 'minAmt', tooltipField: 'minAmt', headerName: 'Minimum Amount' },
  { field: 'maxAmt', tooltipField: 'maxAmt', headerName: 'Maximum Amount', filter: 'agNumberColumnFilter' },
  // { field: 'mdrType', tooltipField: 'mdrType', headerName: 'Payment Type', filter: 'agNumberColumnFilter' },
  { field: 'mdrType', tooltipField: 'mdrType', headerName: 'MDR Type', filter: 'agNumberColumnFilter', 
    cellRenderer: (params: ICellRendererParams): string => {
      return params.value == '1' ? "PERCENTAGE" : "FLAT";
    } },
  // { field: 'mdr_type_name', tooltipField: 'mdr_type_name', headerName: 'Mop Type', filter: 'agNumberColumnFilter' },
   { field: 'mopName', tooltipField: 'mopId', headerName: 'Mop Type', filter: 'agNumberColumnFilter' },
   { field: 'mdr', tooltipField: 'mdr', headerName: 'Mer MDR', filter: 'agNumberColumnFilter' },
  // { field: 'aggr_mdr', tooltipField: 'aggr_mdr', headerName: 'Mer MDR', filter: 'agNumberColumnFilter' },
  { field: 'resellerMdr', tooltipField: 'resellerMdr', headerName: 'Reseller MDR', filter: 'agNumberColumnFilter' },
  { field: 'minMdr', tooltipField: 'minMdr', headerName: 'Minimum MDR', filter: 'agNumberColumnFilter' },
  { field: 'maxMdr', tooltipField: 'maxMdr', headerName: 'Maximum MDR', filter: 'agNumberColumnFilter' },
   { field: 'bankMdr', tooltipField: 'bankMdr', headerName: 'Bank Rate', filter: 'agNumberColumnFilter' },
   { field: 'bankMinMdr', tooltipField: 'bankMinMdr', headerName: 'Minimum Bank Rate', filter: 'agNumberColumnFilter' },
  { field: 'bankMaxMdr', tooltipField: 'bankMaxMdr', headerName: 'Maximum Bank Rate', filter: 'agNumberColumnFilter' },
  { field: 'startDate', tooltipField: 'startDate', headerName: 'Start Date', filter: 'agNumberColumnFilter', 
  cellRenderer: (params: ICellRendererParams): string => {
    return moment(params.value).format('DD-MM-YYYY');
  }  },
  { field: 'endDate', tooltipField: 'endDate', headerName: 'End Date', filter: 'agNumberColumnFilter', 
  cellRenderer: (params: ICellRendererParams): string => {
    return moment(params.value).format('DD-MM-YYYY');
  }  },
  { field: 'resellerMdrType', tooltipField: 'resellerMdrType', headerName: 'Reseller MDR Type', filter: 'agNumberColumnFilter', 
  cellRenderer: (params: ICellRendererParams): string => {
    return params.value == '1' ? "PERCENTAGE" : "FLAT";
  }  
},
  // { field: 'reseller_mdr_type_name', tooltipField: 'reseller_mdr_type_name', headerName: 'Reseller MDR Type', filter: 'agNumberColumnFilter' },
  { field: 'bankMdrType', tooltipField: 'bankMdrType', headerName: 'Bank MDR Type', filter: 'agNumberColumnFilter',cellRenderer: (params: ICellRendererParams): string => {
    return params.value == '1' ? "PERCENTAGE" : "FLAT";
  }  
},
  
   { field: 'currencyName', tooltipField: 'currency', headerName: 'currency', filter: 'agNumberColumnFilter' },


];

  tableSelectedColumn: ColDef[] = [...this.columnDefs];
  Resdata: any;
  Resdatas: any;

  code: any;
  bankdata: any;
  Resbank: any=[];
  merchantId: string;
  bodydata: any;
  randomdata: any;
  Resultdata: any;
  merchantValue: null;
  e: { target: { value: any; }; };
  x: { target: { value: any; }; };
  acquirerId: any;
  bankID: any;
  bankselect: boolean = false;
  paymentType: boolean = false;
  ResinstrumentBrand: any;
  activeIds: string[];
  closeOthers: boolean = true;

  queryParams: any = {};
  toggleDirective = false;
  currentDate: any = new Date();
  newDate: any = new Date();
  resellerResponse: any;
  updateID: any = '0';
  // randomdata: { merchantid: string; };
  highlight: boolean;
  private regex: RegExp = new RegExp(/^\d{0,2}\.?\d{0,2}$/g);
  // Backspace, tab, end, home
  private specialKeys: Array<string> = [
    "Backspace",
    "Tab",
    "End",
    "Home",
    "-",
    "ArrowLeft",
    "ArrowRight",
    "Del",
    "Delete"
  ];
  @ViewChild('acc') private acc: NgbAccordion;
  private gridApi!: GridApi;
  private filterObj: any = {};
  loading: boolean = false;

  constructor(private menuService: MenusService, private el: ElementRef, private merchantService: MerchantService, private alertService: AlertService, private location: Location, private route: ActivatedRoute, private formbuilder: FormBuilder, private datePipe: DatePipe, private apiHttpService: ApiHttpService, private router: Router) {
    this.bankselect = false
    this.paymentType = false
    
    this.merchantMDRform = formbuilder.group({
      merchantId: ["", Validators.required],
      mopType: ["", Validators.required],
      startDate: ["", Validators.required],
      endDate: ["", Validators.required],
      surcharge: ["", Validators.required],
      mid: ["", Validators.required],
      tid: ["", Validators.required],
      minAmt: ["", Validators.required],
      maxAmt: ["", Validators.required],
      mdrType: ["", Validators.required],
      mdr: ["", Validators.required],
      minMdr: ["", Validators.required],
      maxMdr: ["", Validators.required],
      bankMdr: ["", Validators.required],
      bankMdrType: ["", Validators.required],
      bankMinMdr: ["", Validators.required],
      bankMaxMdr: ["", Validators.required],
      cardType: [""],
      encKey: ["",Validators.required],
      minResellerMdr: [""],
      maxResellerMdr: [""],
      resellerMdr: [""],
      resellerMdrType: [""],
      
     // name: ["", [this.regexValidator(new RegExp('^100000.00$|^\\d{0,5}(\\.\\d{1,2})? *%?$'), { flat: true })]],

      acquirerId: ["", Validators.required],
      paymentType: ["", Validators.required],
      adf1: [""], adf2: [""], adf3: [""], adf4: [""], adf5: [""], adf6: [""], adf7: [""], adf8: [""], adf9: [""],
      adf10: [""], adf11: [""],
      currency:["",Validators.required]
    });
  }

  get form1() {
    return this.merchantMDRform.controls;
  }

  changeDate(value: any) {
    this.currentDate = value
  }

  changeEndDate(value: any) {
    this.currentDate = value
  }

   onKeyDown(event: any, el: any, controlValue: any) {
     
    // Allow Backspace, tab, end, and home keys
    console.log(event.key, "----<><", controlValue, "---------->", this.specialKeys, this.specialKeys.indexOf(event.key))
    if (controlValue != 1) {
      return
    }
    if (this.specialKeys.indexOf(event.key) !== -1) {
      console.log(event.key, "--====-->")
      return;
    }
    let current: string = event.target.value;
    console.log(current, "--====-->")
    const position = el.selectionStart;
    console.log(position, "--====-->")
    const next: string = [
      current.slice(0, position),
      event.key == "Decimal" ? "." : event.key,
      current.slice(position)
    ].join("");

    const beforeDecimal: any = next.split(".")[0];
    const AfterDecimal: any = next.split(".")[1];
    const checkDotFirstPosition: string = next.substring(0, 1);
    if (next === "00") {
      event.preventDefault();
    }
    if (checkDotFirstPosition === ".") {
      event.preventDefault();
    }
    if (beforeDecimal) {
      if (beforeDecimal <= 100) {
        if (beforeDecimal.toString().length >= 4) {
          event.preventDefault();
        }
      } else {
        if (beforeDecimal.toString().length >= 3) {
          event.preventDefault();
        }
      }
    }
    if (AfterDecimal) {
      if (AfterDecimal.toString().length >= 3) {
        event.preventDefault();
      }
    }
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
   }

  ngOnInit(): void {

    this.merchantMDRform.get('instrumentBrand')?.setValidators([])
    this.merchantMDRform.get('instrumentBrand')?.updateValueAndValidity()
    const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = this.menuService.getPermissions(path);
    this.route.queryParams
      .subscribe(params => {
        this.queryParams = params;
        this.merchantId = params?.mid
        // this.merchantService.getMerchant(params?.mid).subscribe((res: any) => {
        //   this.resellerResponse = res[0].reseller_id;
        //   console.log("this.resellerResponse--->", this.resellerResponse, res[0])
        //   if (!this.resellerResponse || this.resellerResponse == '' || this.resellerResponse == '0') {
        //     this.merchantMDRform.get('minResellerMdr')?.clearValidators();
        //     this.merchantMDRform.get('maxResellerMdr')?.clearValidators();
        //     this.merchantMDRform.get('resellerMdrType')?.clearValidators();
        //     this.merchantMDRform.get('resellerMdr')?.clearValidators();

        //     this.merchantMDRform.get('minResellerMdr')?.updateValueAndValidity();
        //     this.merchantMDRform.get('maxResellerMdr')?.updateValueAndValidity();
        //     this.merchantMDRform.get('resellerMdrType')?.updateValueAndValidity();
        //     this.merchantMDRform.get('resellerMdr')?.updateValueAndValidity();



        //   }else{

        
        //     this.merchantMDRform.get('minResellerMdr')?.setValidators(Validators.required);
        //     this.merchantMDRform.get('maxResellerMdr')?.setValidators(Validators.required);
        //     this.merchantMDRform.get('resellerMdrType')?.setValidators(Validators.required);
        //     this.merchantMDRform.get('resellerMdr')?.setValidators(Validators.required);

        //     this.merchantMDRform.get('minResellerMdr')?.updateValueAndValidity();
        //     this.merchantMDRform.get('maxResellerMdr')?.updateValueAndValidity();
        //     this.merchantMDRform.get('resellerMdrType')?.updateValueAndValidity();
        //     this.merchantMDRform.get('resellerMdr')?.updateValueAndValidity();



        //   }

        // });
        if (this.merchantId) {
          this.merchantMDRform.get('merchantId')?.patchValue(this.merchantId);
          this.merchantMDRform.get('merchantId')?.disable();
        }
      }
      );

    this.isForm1Submitted = false;
    this.MerchnatList();
    this.acquirerList();
    this.fetchCardType();
    var e = {
      "target": { 'value': "" }
    }
    var x = {
      "target": { 'value': "" }
    }
    this.onAquirerChnage(e);
    this.onPaymentTypeChange(x);
    this.bankselect = false
    this.paymentType = false
    this.activeIds = ['pan-1'];
    const mdrTypeCtrl = <FormControl>this.merchantMDRform.get('mopType');

    if (!(this.permissions.includes('Add') || this.permissions.includes('Edit'))) {
 
      this.merchantMDRform.disable({
        onlySelf: true,
        emitEvent: true
      });

      this.columnDefs.push({
        field: 'Action', resizable: true, cellRenderer: BtnCellRenderer, cellRendererParams: [
          {
            clicked: async (field: any, param: any) => {
              this.tableInfo = param.data
              this.Edit(this.tableInfo)
            },
            buttonIconClass: 'icon-eye'
          }
        ]
      });


    } else {
      this.columnDefs.push({
        field: 'Action', resizable: true, cellRenderer: BtnCellRenderer, cellRendererParams: [
          {
            clicked: async (field: any, param: any) => {
              this.tableInfo = param.data
              this.delete(this.tableInfo)
              this.alertService.confirmBox(this.delete(this.tableInfo), {}, {
                html: "Record has been deleted.!"
              }, () => {
                this.refreshGrid(this.merchantId);
              })

            },
            buttonIconClass: 'icon-trash',
            buttonDisable: (this.permissions.includes('Add') || this.permissions.includes('Edit'))
          },

          {
            clicked: async (field: any, param: any) => {
              this.tableInfo = param.data
              this.Edit(this.tableInfo)
            },
            buttonIconClass: 'icon-edit-2'
          }
        ]
      })
    }
    this.updateID = '0'
  }

  regexValidator(regex: RegExp, error: ValidationErrors): ValidatorFn | null {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value) {
        return null;
      }
      const valid = regex.test(control.value);
      return valid ? null : error;
    };
  }
  ngAfterViewInit() {
    this.updateID = '0'
  }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term: string) => term.length < 2 ? []
        : this.rowData.filter(v => (v.merchantId.toLowerCase().indexOf(term.toLowerCase()) > -1)).map(v => v.merchantId).slice(0, 10))
    );

  loadDatabyMid() {

    this.refreshGrid(this.merchantId);
    this.bankselect = false
    this.paymentType = false
  }

  onGridReady(params: GridReadyEvent<any>) {
     
    if (this.merchantMDRform.controls['merchantId'].value === "") {
      this.merchantValue = null
    } else {
      this.merchantValue = this.merchantMDRform.controls['merchantId'].value
    }
    let data = {
      "merchantId": this.merchantId || this.merchantValue
    }

    this.gridApi = params.api;
    this.gridApi.setColumnDefs(this.columnDefs);
    this.gridApi.getFilterInstance('age', (filterParam) => {
    })
    this.gridApi.showLoadingOverlay();

    // return this.apiHttpService
    //   .post(
    //     `${API_URL}/getMerchantMDRList?pageSize=${this.pageSize}&page=${(this.currentPage - 1)}`, data
    //   )
    //   .subscribe((data) => {
    //     this.collectionSize = data?.totalCount || data?.length
    //     console.log("data deepak2"+JSON.stringify(data));
    //     this.rowData = (data?.data || Array.isArray(data) ? data : []).map((d: any) => {
    //      // console.log("this.rowData deepak======"+this.rowData);
    //       //alert()
    //       return {
    //         ...d,
    //       }
    //     })
    //   });
    this.rowData = [];

  }

  onBtnC(e: Event) {
    e.preventDefault();
    // @ts-ignore
    if (this.merchantMDRform.controls['merchantId'].value === "") {
      this.merchantValue = null
    } else {
      this.merchantValue = this.merchantMDRform.controls['merchantId'].value
    }
    let data = {
      "merchantId": this.merchantId || this.merchantValue
      // "merchantid": this.merchantId || "M0003"
    }
    return this.apiHttpService
      .post(
        `${API_URL}/getMerchantMDRList`, data
      )
      // @ts-ignore
      .subscribe((data) => {
        console.log("data deepak2"+data);
        this.rowData = data?.data || Array.isArray(data) ? data : [];
        console.log(" this.rowData  deepak2"+ this.rowData);
        this.collectionSize = data?.totalCount || data?.length
        this.gridApi.applyTransaction({ add: this.rowData });
        // this.collectionSize = data?.totalCount || data?.length

      });
  }

  resetMDR(control: any) {

  //   this.merchantMDRform.controls['resellerMdr'].enable()
  //   this.merchantMDRform.controls['minResellerMdr'].enable()
  //   this.merchantMDRform.controls['resellerMdr'].setValidators([Validators.required])
  //  // this.merchantMDRform.controls['minResellerMdr'].updateValueAndValidity();
  //   this.merchantMDRform.controls['minResellerMdr'].setValidators([Validators.required]);
  //   //this.merchantMDRform.controls['minResellerMdr'].updateValueAndValidity();

   
  }

  onExportCSV() {
    // Direct use AgGrid fucntioanlity
    var random3 = Math.floor(Math.random() * 10000000000 + 1);
    var today = new Date();
    var referenceId = today.getFullYear().toString() + "-" + ("0" + (today.getMonth() + 1)).slice(-2) + "-" + ("0" + today.getDate()).slice(-2) + "_" + (("0" + today.getHours())).slice(-2) + "-" + (("0" + today.getMinutes())).slice(-2) + "-" + (("0" + today.getSeconds())).slice(-2)
    var fileName = 'Merchant_Mdr' + "_" + referenceId
    var params = {
      skipHeader: false,
      skipFooters: true,
      allColumns: true,
      onlySelected: false,
      suppressQuotes: true,
      fileName: fileName + '.csv',
      columnSeparator: ','
    };
    this.gridApi.exportDataAsCsv(params)
  }
  fun(id: any) {
    document?.getElementById(id)?.classList.add("hey")
  }
  funover(id: any) {
    document?.getElementById(id)?.classList.remove("hey")
  }

  updateSelectedTimeslots(event: any) {
     
    if (event.target.checked) {
      if (this.tableSelectedColumn.indexOf(this.columnDefs[parseInt(event.target.value)]) < 0) {
        this.tableSelectedColumn.splice(parseInt(event.target.value), 0, this.columnDefs[parseInt(event.target.value)]);
      }
    } else {
      if (this.tableSelectedColumn.indexOf(this.columnDefs[parseInt(event.target.value)]) > -1) {
        this.tableSelectedColumn.splice(this.tableSelectedColumn.indexOf(this.columnDefs[parseInt(event.target.value)]), 1);
      }
    }
    this.gridApi.setColumnDefs(this.tableSelectedColumn)
    this.gridApi.setDefaultColDef(this.defaultColDef);
  }

  onPaginationChange(param: PaginationChangedEvent | any) {
    this.gridApi.paginationGoToPage(param - 1)
  }

  async onRowClicked(param: RowClickedEvent | any) {
     
    this.SingleRow = param.data

  }

  onRowDoubleClicked(param: RowClickedEvent | any) {
    param.node.setExpanded(!param.node.expanded);
  }

  onFilterChange(param: FilterChangedEvent | any) {
    if (this.merchantMDRform.controls['merchantId'].value === "") {
      this.merchantValue = null
    } else {
      this.merchantValue = this.merchantMDRform.controls['merchantId'].value
    }
    let Requestbody = {
      "merchantId": this.merchantId || this.merchantValue
    }

    // this.rowData.length = 0
    this.gridApi.applyTransaction({ remove: this.rowData })
    this.gridApi.showLoadingOverlay();

    const self = this;

    self.apiHttpService
      .post(
        `${API_URL}/getMerchantMDRList?pageSize=${this.pageSize}&page=${(this.currentPage - 1)}`, Requestbody
      )
      // @ts-ignore
      .subscribe((data) => {
        self.gridApi.applyTransaction({
          add: data?.filter((dt: any) => {
            if (dt.age == self.filterObj?.age?.appliedModel.filter)
              return dt;
          })
        });

        this.collectionSize = data?.totalCount || data?.length
      });


  }

  onFilterModified(param: FilterModifiedEvent | any) {
     
    const temp = param?.filterInstance;
    this.filterObj[param?.column?.colId] = temp;
  }

  onFilterOpened(param: FilterOpenedEvent | any) {
    console.log("onFilterOpened----->", param);
  }

  onPageSizeChanges($event: Event) {

    if (this.merchantMDRform.controls['merchantId'].value === "") {
      this.merchantValue = null
    } else {
      this.merchantValue = this.merchantMDRform.controls['merchantId'].value
    }
    let Requestbody = {
      // "merchantid": this.merchantId || "M0002",
      "merchantId": this.merchantId || this.merchantValue
    }

    this.gridApi.paginationSetPageSize(this.pageSize)
    this.gridApi.applyTransaction({ remove: this.rowData })
    this.gridApi.showLoadingOverlay();
    this.apiHttpService
      .post(
        `${API_URL}/getMerchantMDRList?pageSize=` + this.pageSize + '&page=' + (this.currentPage - 1), Requestbody
      )
      .subscribe((data) => (
      
        this.rowData = data?.data || Array.isArray(data) ? data : [],
        this.collectionSize = data?.totalCount,
        this.gridApi.applyTransaction({ add: this.rowData })
      ));

  }

  //call create merchant MDR api
  onSubmit(formvalue: any) {
     
    if (this.merchantMDRform.valid) {
      let valMinAmount = parseFloat(formvalue.minAmt);
      let valMaxAmount =parseFloat( formvalue.maxAmt);
      if (valMinAmount>0){
      if(valMaxAmount>valMinAmount){
    this.closeOthers = true;
    this.selectedMerchantID = this.merchantId || formvalue.merchantId
    this.acquirerId = formvalue.acquirerId
    this.bankID = formvalue.bank_id
    let MDRADD = {
      "merchantId": this.merchantId || formvalue.merchantId,
      "acquirerId": formvalue.acquirerId || '',
      "bankId": formvalue.bank_id || 0,
      "paymentType": formvalue.paymentType || '',
      "minAmt": formvalue.minAmt || 0,
      "maxAmt": formvalue.maxAmt || 0,
      "mopId": formvalue.mopType || '',
      "mdrType": formvalue.mdrType || '',
      "mdr": formvalue.mdr || '',
      "minMdr": formvalue.minMdr || '',
      "maxMdr": formvalue.maxMdr || '',
      "cardType": formvalue.cardType || '',
      "bankMdrType": formvalue.bankMdrType || '',
      "bankMdr": formvalue.bankMdr || '',
      "bankMinMdr": formvalue.bankMinMdr || '',
      "bankMaxMdr": formvalue.bankMaxMdr || '',
      "mid": formvalue.mid || '',
      "tid": formvalue.tid || '',
      "encKey": formvalue.encKey,
      "startDate": formvalue.startDate || '',
      "endDate": formvalue.endDate || '',
      "surcharge": formvalue.surcharge || '',
      "adf1": formvalue.adf1 || '',
      "adf2": formvalue.adf2 || '',
      "adf3": formvalue.adf3 || '',
      "adf4": formvalue.adf4 || '',
      "adf5": formvalue.adf5 || '',
      "adf6": formvalue.adf6 || '',
      "adf7": formvalue.adf7 || '',
      "adf8": formvalue.adf8 || '',
      "adf9": formvalue.adf9 || '',
      "adf10": formvalue.adf10 || '',
      "adf11": formvalue.adf11 || '',
      "resellerMdr": formvalue.resellerMdr || 0,
      "minResellerMdr": formvalue.minResellerMdr || 0,
      "maxResellerMdr": formvalue.maxResellerMdr || 0,
      "resellerMdrType": formvalue.resellerMdrType || '',
      "currency":formvalue.currency || '',

    }

     
    console.log("Calling mdr setup API....");
    console.log(MDRADD);
    
    
    this.loading = true
    document?.getElementById('loading')?.classList.add("spinner-border")
    document?.getElementById('loading')?.classList.add("spinner-border-sm")
    this.apiHttpService
      .post(
        //`${API_URL}/createorupdate-merchantmdrlist`,
        // "https://globaldev.pay10.com/mdr-setup/api/v1/update-mdr",
        `${API_URL}/update-mdr`,
         MDRADD
      )
      .subscribe((data) => {
        this.loading = false
        document?.getElementById('loading')?.classList.remove("spinner-border")
        document?.getElementById('loading')?.classList.remove("spinner-border-sm");
        console.log(data);
        // if (!data?.error) {
        //   this.alertService.successAlert(data.merchantId!=null ? "Merchant's MDR Details Updated Successfully.!" : "Merchant's MDR Details Added Successfully.!");
        // }
        // this.merchantMDRform.reset();
        // this.merchantMDRform.markAsUntouched();
        // this.merchantMDRform.updateValueAndValidity();
        if (!data?.error) {
          this.alertService.successAlert(data.msg ? "Merchant's MDR Details Updated Successfully.!" : "Merchant's MDR Details Added Successfully.!");
        }
        this.rowData = data.data || Array.isArray(data) ? data : [];
        console.log("rowData deepak4"+this.rowData)
        console.log("data deepak3"+data);
        
        this.collectionSize = data.totalCount || data.length;

        this.randomdata = {
          "merchantId": (this.merchantId || this.merchantMDRform.controls['merchantId'].value == "" ? null : this.merchantMDRform.controls['merchantId'].value) || this.selectedMerchantID
        };
        this.merchantMDRform.reset();
        this.merchantMDRform.controls['acquirerId'].setValue("")
        this.merchantMDRform.controls['paymentType'].setValue("")

        this.merchantMDRform.controls['mopType'].setValue("")

        this.merchantMDRform.markAsUntouched();
        this.merchantMDRform.updateValueAndValidity();
        this.isForm1Submitted = false;
        this.merchantMDRform.get('merchantId')?.patchValue(this.merchantId);
        this.merchantMDRform.get('merchantId')?.disable();
        this.mindatadis=true;
        this.maxdatadis=true;
        this.apiHttpService
          .post(
            `${API_URL}/getMerchantMDRList?pageSize=${this.pageSize}&page=${(this.currentPage - 1)}`, this.randomdata
          )
          .subscribe((data) => {
            this.rowData = data?.data || Array.isArray(data) ? data : [];
            console.log("rowData deepak3"+this.rowData)
            this.collectionSize = data?.totalCount || data?.length;

            this.bankselect = false;
            this.paymentType = false
          })
        this.refreshGrid(this.selectedMerchantID || this.merchantId);

      }, (error) => {
        console.log("Error------>", error);
      });

    this.reset()
    this.merchantMDRform.controls['acquirerId'].setValue("")


    this.merchantMDRform.get('merchantId')?.patchValue(this.merchantId);
    this.merchantMDRform.get('merchantId')?.disable();

    this.bankselect = false
    this.paymentType = false
  }else{
    this.maxdatadis=false;
    this.mindatadis=true;

    this.closeOthers = false;
    this.acc.expandAll();
  }
      }else{
        this.maxdatadis=true;

        this.mindatadis=false;

        this.closeOthers = false;
        this.acc.expandAll();    }
  




    } else {
      this.closeOthers = false;
      this.acc.expandAll();
    }
    this.isForm1Submitted = true;
  }

  //get merchant By Name
  MerchnatList() {
    let merchantdata = { "name": "" }
    this.apiHttpService
      .post(`${API_URL}/GetMerchant`, merchantdata)
      .subscribe((res) => {
        this.Resultdata = res
      });
  }

  currencyData:any[]=[   
    this.apiHttpService
    .get(`${API_URL}/currencyList`)
    .subscribe((res) => {
      console.log("currency list fetched..............");
      console.log(res);

      this.currencyData = res

    })     
  ]

  
  async Edit(Editvalue: any) {

    //console.log("EditValue: "+Editvalue.acquirerId);
    
   // const merchantSubCategory$ = this.merchantService.getService(Editvalue.acquirerId);
   // this.Resdatas = await lastValueFrom(merchantSubCategory$);
   // console.log("Value for RESDATA "+this.Resdatas);
   // this.Resdatas=Editvalue.acquirerId;
    // const merchantSubCategory12$ = this.merchantService.getInstruments(Editvalue.acquirerId+ '#' +Editvalue.paymentType);
    // this.Resbank = await lastValueFrom(merchantSubCategory12$);
    const bankCategory$ = this.merchantService.getInstruments(Editvalue.acquirerId + '#' + Editvalue.paymentType)
    //this.Resbank = await lastValueFrom(bankCategory$);
   // console.log(this.Resdatas);
  //  this.Resbank=Editvalue.mopName;
    //this.Resbank=Editvalue.paymentName;
    let url=`${API_URL}`+"/fetchMDRComplete/"+Editvalue.id
   
  this.apiHttpService
  .post(
    url , null
  )
  .subscribe((data12) => {

     Editvalue.adf1=data12.adf1
     Editvalue.adf2=data12.adf2
    Editvalue.adf3=data12.adf3
    Editvalue.adf4=data12.adf4
    Editvalue.adf5=data12.adf5
     Editvalue.adf6=data12.adf6
     Editvalue.adf7=data12.adf7
    Editvalue.adf8=data12.adf8
     Editvalue.adf9=data12.adf9
    Editvalue.adf10=data12.adf10
     Editvalue.adf11=data12.adf11
    Editvalue.mid=data12.mid
     Editvalue.tid=data12.tid
     Editvalue.encKey=data12.encKey
     Editvalue.mdr=data12.mdr
     Editvalue.start_date=data12.responseEndDate
     Editvalue.end_date=data12.responseEndDate
     Editvalue.currency=data12.currency;
 
    this.bankselect = true
    this.paymentType = true
    this.updateID = Editvalue.id
    
    // const llT = await this.seletservice(Editvalue.sp_id.toString());
    
   
    this.acc.expand('pan-1');
    setTimeout(() => {
      console.log(Editvalue);
      
     this.onAquirerChnage(Editvalue.acquirerId);
     this.getPaymentType(Editvalue.paymentType);
    
      // console.log("Payment Type: "+Editvalue.paymentType);
      
      this.merchantMDRform.patchValue({
        "merchantId": Editvalue.merchantId,
     //   "paymentType": this.Resdatas.find((inst: any) => inst.FieldValue == Editvalue.paymentType) ? Editvalue.paymentType : '',
      //  "mopType": this.Resbank.find((inst: any) => inst.FieldValue == Editvalue.mopId) ? Editvalue.mopId : '',
       // "acquirerId":this.Resdata.find((inst: any) => inst.FieldValue == Editvalue.acquirerId) ? Editvalue.acquirerId : '',
        "acquirerId" :Editvalue.acquirerId ,
        "paymentType": Editvalue.paymentName,
        "mopType":  Editvalue.mopId,
        "minAmt": Editvalue.minAmt,
        "maxAmt": Editvalue.maxAmt,
        "minMdr": Editvalue.minMdr,
        "maxMdr": Editvalue.maxMdr,
        "mid": Editvalue.mid,
        "tid": Editvalue.tid,
        "encKey": Editvalue.encKey,
        "minResellerMdr": Editvalue.minResellerMdr,
        "maxResellerMdr": Editvalue.maxResellerMdr,
        "resellerMdr": Editvalue.resellerMdr,
        "resellerMdrType": Editvalue.resellerMdrType,
        "mdrType":Editvalue.mdrType,
        "bankMdrType":Editvalue.bankMdrType,
        "startDate":Editvalue.start_date,
        "endDate": Editvalue.end_date,

        // "startDate":Editvalue.start_date? this.datePipe.transform(moment(Editvalue.start_date, 'D-M-YYYY').format('YYYY-MM-DD'), "yyyy-MM-dd"):null,
        // "endDate": Editvalue.end_date?this.datePipe.transform(moment(Editvalue.end_date, 'D-M-YYYY').format('YYYY-MM-DD'), "yyyy-MM-dd"):null,
         "prefrences": Editvalue.prefrences,
        "surcharge": Editvalue.surcharge,
        "cardType": Editvalue.cardType,
        "bankMinMdr": Editvalue.bankMinMdr,
        "bankMaxMdr": Editvalue.bankMaxMdr,
        "bankMdr": Editvalue.bankMdr,
		    "adf1": Editvalue.adf1,
		    "adf2": Editvalue.adf2,
		    "adf3": Editvalue.adf3,
		    "adf4": Editvalue.adf4,
		    "adf5": Editvalue.adf5,
		    "adf6": Editvalue.adf6,
		    "adf7": Editvalue.adf7,
		    "adf8": Editvalue.adf8,
		    "adf9": Editvalue.adf9,
		    "adf10": Editvalue.adf10,
		    "adf11": Editvalue.adf11,
        "mdr":Editvalue.mdr,
        "currency":this.currencyData.find((inst: any) => inst.code == Editvalue.currency) ? Editvalue.currency : '',
      })
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });

      this.highlight = false;
      this.accPan.nativeElement.focus();
      setTimeout(() => {
        this.highlight = true;

      }, 1000);
    }, 0);
    // }


  })


  }

  reset() {
    this.merchantMDRform.reset(); // Reset form data
    this.updateID = '0';
    this.merchantMDRform.patchValue({
      "acquirerId": '',
      "bank_id": '',
      "paymentType": '',
      "minAmt": '',
      "maxAmt": '',
      "mdrType": '',
      "aggrMdr": '',
      "resellerMdr": '',
      "baseRate": '',
      "minBaseRate": '',
      "maxBaseRate": '',
      "minMdr": '',
      "maxMdr": '',
      "mid": '',
      "tid": '',
      "startDate": '',
      "endDate": '',
      "prefrences": '',
      "surcharge": '',
      "cardVariantName": '',
      "network": '',
      "bankMdrType": '',
      "resellerMdrType": '',
      "minResellerMdr": '',
      "maxResellerMdr": '',
      "instrumentBrand": '',
    })
    this.merchantMDRform.markAsUntouched(); // Reset form data
    this.merchantMDRform.updateValueAndValidity(); // Reset form data
  }

  // end call api serviceProvide dropdown

  //call api serviceProvide dropdown
  acquirerList() {

    // let serviceprovidedata = {
    //   "Type": "5",
    //   "Value": ""
    // }
    // this.apiHttpService
    //   .post(`${API_URL}/GetAcqPaymentDetails`, serviceprovidedata)
    //   .subscribe((res) => {
    //     console.log("Acquirer list fetched..............");
    //     console.log(res);

    //     this.Resdata = res

    //   });
  }

  // end call api instrument dropdown

  // call api instrument dropdown
  onAquirerChnage(e: any) {
    this.paymentType = true
    // this.code = e?.target?.value || e;
    // this.merchantMDRform.controls['paymentType'].setValue("")
    // // return ;
    // let serviceprovidedata = {
    //   "Type": "6",
    //   "Value": this.code
    // }
    // return this.apiHttpService
    //   .post(
    //     `${API_URL}/GetAcqPaymentDetails`, serviceprovidedata
    //   )
    //   .subscribe((res) => {
    //     this.Resdatas = res
    //     return res;
    //   });
  }

   onCurrencyChanage(event:any){
    let code =event.target.value;
    this.merchantMDRform.controls['currency'].setValue("");
  }

  // end api call  for bank select dropdown

  // call api for bank select dropdown
  onPaymentTypeChange(e: any) {
    this.bankselect = true
    // this.bankdata = e.target.value;
    // if (this.bankdata == "CC" || this.bankdata == "DC") {
    
    // }
    // const providerVal = this.code;//this.merchantMDRform.get('acquirerId')?.value
    // console.log("Value "+this.code);
    
    // let serviceprovidedata = {
    //   "Type": "7",
    //   "Value": providerVal + '#' + this.bankdata
    // }
    // this.apiHttpService
    //   .post(
    //     `${API_URL}/GetAcqPaymentDetails`, serviceprovidedata
    //   )
    //   .subscribe((res) => {
    //     this.Resbank = res
    //   });
  }

  getPaymentType(e:any){
    this.bankselect = true
    // this.bankdata = e;
    // if (this.bankdata == "CC" || this.bankdata == "DC") {
    
    // }
    // const providerVal = this.code;//this.merchantMDRform.get('acquirerId')?.value
    // console.log("Value "+this.code);
    
    // let serviceprovidedata = {
    //   "Type": "7",
    //   "Value": providerVal + '#' + this.bankdata
    // }
    // this.apiHttpService
    //   .post(
    //     `${API_URL}/GetAcqPaymentDetails`, serviceprovidedata
    //   )
    //   .subscribe((res) => {
    //     this.Resbank = res
    //   });
  }




  cardTypeList: any;
  fetchCardType() {
    let data = {
      "Type": "14",
      "Value": ""
    }
    this.apiHttpService.post(`${API_URL}/GetDropdown`, data)
      .subscribe((res) => {
        this.cardTypeList = res
      });
  }

  delete(deletedata: any) {
    let data = {
      
    }
    let url=`${API_URL}`+"/delete-mdr/"+deletedata.id
 
    return this.apiHttpService
      .post(
        url,data
 )
  }


  keyPressNumbers(event:any) {
    var inp = String.fromCharCode(event.keyCode);

    if (/[a-zA-Z0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  } 
  OnlyCharacterNumberAllowed(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 33 && charCode <= 126)) {
      // console.log('charCode restricted is' + charCode)
      return true;
    }
    return false;
  }
  refreshGrid(Mid?: any) {
    if (this.merchantMDRform.controls['merchantId'].value === "") {
      this.merchantValue = null
    } else {
      this.merchantValue = this.merchantMDRform.controls['merchantId'].value
    }
    let data = {
      "merchantId": this.merchantId || this.merchantValue || Mid
    }
    this.gridApi.showLoadingOverlay();

    return this.apiHttpService
      .post(
        `${API_URL}/getMerchantMDRList?pageSize=${this.pageSize}&page=${(this.currentPage - 1)}`, data
      )
      .subscribe((data) => {
        console.log("data deepak1"+data);
        // this.rowData = data?.data || Array.isArray(data) ? data : [];
        this.collectionSize = data?.totalCount || data?.length;
        this.rowData = (data?.data || Array.isArray(data) ? data : []).map((d: any) => {
          return {
            ...d
          }
        })
        console.log("rowData deepak5"+this.rowData);
      });
  }


  
  noKeyInput($event: any) {
    return false
  }

  //validation for number only
  onlyNumbersAllowed(event: { which: any; keyCode: any; }): boolean {
     
    const charCode = (event.which) ? event.which : event.keyCode;
    return (charCode > 47 && charCode < 58) || charCode == 46;
  }

  //end the validtion
}
